import { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';

import { Button } from '@/Components/Button';
import { ExclamationSvg } from '@/Components/Icons/ExclamationSvg';
import { LogoSvg } from '@/Components/Icons/LogoSvg';
import { ModalView } from '@/Components/ModalView';

type PreflightFailureModalProps = {
    onClose: () => void;
};

export const PreflightFailureModal: FC<PreflightFailureModalProps> = ({
    onClose,
}) => {
    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            onSubmit={onClose}
            contentContainerClassName="py-6 px-8 text-brand-ocean flex flex-col justify-center items-center">
            <div className="flex flex-row items-center justify-center">
                <LogoSvg className="mb-8 -mr-1.5" />
                <ExclamationSvg className="[&_path]:fill-brand-red" />
            </div>
            <div className="w-full text-left mb-1 text-body-text-15 text-brand-ocean grid gap-4">
                <p>Your flow couldn’t be published because it is not ready.</p>
                <p>
                    Please check for red dots in the Flow Builder to fix the
                    issues and try again.
                </p>
            </div>
            <div className="mt-2 w-full flex flex-row items-center justify-center">
                <Button
                    className="flex-1 h-9"
                    variant="default"
                    onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </ModalView>
    );
};
